import React, { useState, useEffect } from 'react';
import { Modal, Header, Icon, Button } from 'semantic-ui-react';
import './AchievementNotification.css';

const AchievementNotification = ({ achievement, isVisible, onClose }) => {
    const [showFireworks, setShowFireworks] = useState(false);

    useEffect(() => {
        if (isVisible) {
            setShowFireworks(true);
            // Auto close after 5 seconds
            const timer = setTimeout(() => {
                onClose();
            }, 5000);

            return () => clearTimeout(timer);
        }
    }, [isVisible, onClose]);

    const handleClose = () => {
        setShowFireworks(false);
        onClose();
    };

    if (!achievement) return null;

    return (
        <>
            {/* Background Fireworks Animation */}
            {showFireworks && (
                <div className="fireworks-container">
                    <div className="firework firework-1">
                        <div className="explosion">
                            <div className="spark"></div>
                            <div className="spark"></div>
                            <div className="spark"></div>
                            <div className="spark"></div>
                            <div className="spark"></div>
                            <div className="spark"></div>
                            <div className="spark"></div>
                            <div className="spark"></div>
                        </div>
                    </div>
                    <div className="firework firework-2">
                        <div className="explosion">
                            <div className="spark"></div>
                            <div className="spark"></div>
                            <div className="spark"></div>
                            <div className="spark"></div>
                            <div className="spark"></div>
                            <div className="spark"></div>
                        </div>
                    </div>
                    <div className="firework firework-3">
                        <div className="explosion">
                            <div className="spark"></div>
                            <div className="spark"></div>
                            <div className="spark"></div>
                            <div className="spark"></div>
                            <div className="spark"></div>
                        </div>
                    </div>
                </div>
            )}

            {/* Box Fireworks - Shooting from all sides */}
            {showFireworks && (
                <div className="box-fireworks-container">
                    {/* Top side fireworks */}
                    <div className="box-firework box-firework-top-1"></div>
                    <div className="box-firework box-firework-top-2"></div>
                    
                    {/* Right side fireworks */}
                    <div className="box-firework box-firework-right-1"></div>
                    <div className="box-firework box-firework-right-2"></div>
                    
                    {/* Bottom side fireworks */}
                    <div className="box-firework box-firework-bottom-1"></div>
                    <div className="box-firework box-firework-bottom-2"></div>
                    
                    {/* Left side fireworks */}
                    <div className="box-firework box-firework-left-1"></div>
                    <div className="box-firework box-firework-left-2"></div>
                    
                    {/* Corner diagonal fireworks */}
                    <div className="box-firework box-firework-corner-tl"></div>
                    <div className="box-firework box-firework-corner-tr"></div>
                    <div className="box-firework box-firework-corner-bl"></div>
                    <div className="box-firework box-firework-corner-br"></div>
                </div>
            )}

            {/* Achievement Modal */}
            <Modal
                open={isVisible}
                onClose={handleClose}
                size="small"
                dimmer="blurring"
                className="achievement-modal"
            >
                <Modal.Content style={{
                    textAlign: 'center',
                    padding: '40px',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    borderRadius: '12px'
                }}>
                    <div style={{ marginBottom: '20px' }}>
                        <Icon 
                            name="trophy" 
                            size="huge" 
                            style={{ 
                                color: '#ffd700',
                                textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                                animation: 'bounce 1s infinite alternate'
                            }} 
                        />
                    </div>

                    <Header as="h1" style={{ 
                        color: 'white', 
                        fontFamily: 'Montserrat',
                        fontSize: '2.5em',
                        marginBottom: '10px',
                        textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
                    }}>
                        🎉 Achievement Unlocked! 🎉
                    </Header>

                    <div style={{
                        backgroundColor: 'rgba(255,255,255,0.2)',
                        borderRadius: '12px',
                        padding: '20px',
                        margin: '20px 0',
                        backdropFilter: 'blur(10px)',
                        border: '1px solid rgba(255,255,255,0.3)',
                        position: 'relative'
                    }}>
                        {/* Confetti coming out of the achievement box */}
                        {showFireworks && (
                            <div className="confetti-container">
                                <div className="confetti-piece"></div>
                                <div className="confetti-piece"></div>
                                <div className="confetti-piece"></div>
                                <div className="confetti-piece"></div>
                                <div className="confetti-piece"></div>
                                <div className="confetti-piece"></div>
                                <div className="confetti-piece"></div>
                                <div className="confetti-piece"></div>
                                <div className="confetti-piece"></div>
                                <div className="confetti-piece"></div>
                                <div className="confetti-piece"></div>
                                <div className="confetti-piece"></div>
                                <div className="confetti-piece"></div>
                                <div className="confetti-piece"></div>
                                <div className="confetti-piece"></div>
                                <div className="confetti-piece"></div>
                            </div>
                        )}
                        
                        <div style={{ 
                            fontSize: '4em', 
                            marginBottom: '10px',
                            animation: 'pulse 2s infinite'
                        }}>
                            {achievement.icon}
                        </div>
                        
                        <Header as="h2" style={{ 
                            color: 'white',
                            fontFamily: 'Montserrat',
                            marginBottom: '10px'
                        }}>
                            {achievement.name}
                        </Header>
                        
                        <p style={{ 
                            fontSize: '1.2em',
                            marginBottom: '0',
                            fontFamily: 'Montserrat',
                            opacity: 0.9
                        }}>
                            {achievement.description}
                        </p>
                    </div>

                    <Button
                        onClick={handleClose}
                        style={{
                            backgroundColor: '#ffd700',
                            color: '#333',
                            fontFamily: 'Montserrat',
                            fontWeight: 'bold',
                            padding: '12px 24px',
                            fontSize: '1.1em',
                            border: 'none',
                            borderRadius: '25px',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#ffed4e';
                            e.target.style.transform = 'scale(1.05)';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.backgroundColor = '#ffd700';
                            e.target.style.transform = 'scale(1)';
                        }}
                    >
                        Awesome! 🚀
                    </Button>
                </Modal.Content>
            </Modal>

            <style jsx>{`
                @keyframes bounce {
                    from { transform: translateY(0px); }
                    to { transform: translateY(-10px); }
                }

                @keyframes pulse {
                    0% { transform: scale(1); }
                    50% { transform: scale(1.1); }
                    100% { transform: scale(1); }
                }
            `}</style>
        </>
    );
};

export default AchievementNotification;